export default "__VITE_ASSET__49d1436b__"